//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postFakeLogin,
  postJwtLogin,
  postLogin,
  update_user_image,
  update_user_details,
  get_user_details,
  fetch_plan_summary
} from "../../../helpers/fakebackend_helper";

import { loginSuccess, logoutUserSuccess, apiError, reset_login_flag, enable_login_loader, set_user_image_success, set_user_image_fail , update_user_details_success } from './reducer';
import { useNavigate } from "react-router-dom";
import { open_success_modal } from "../../Success_Modal/reducer";



export const loginUser = (user,navigate) => async (dispatch) => {



  try {
    let response;


    dispatch(enable_login_loader())
    
 
      response = postLogin({
        email: user.email,
        password: user.password,
      });
    
    
    var data = await response;






    if (data) {
       localStorage.setItem('authUser', JSON.stringify(data));
       localStorage.setItem('user_image',(data.Details.user_image))
       const plan_details = await fetch_plan_summary()

      //  console.log(plan_details , "Plan Summary ...")
       if(JSON.stringify(plan_details) === '{}'){
          navigate('/bots')
          dispatch(loginSuccess(data));
       }else{
          dispatch(loginSuccess(data));
          navigate('/bots')

       }
  
   
    }
  } catch (error) {
    console.log("Error" , error);
    
    dispatch(apiError(error));
  }
};

export const logoutUser = () => async (dispatch) => {
  
  try {
    


      dispatch(logoutUserSuccess(true));
      


  } catch (error) {
    dispatch(apiError(error));
  }
};

export const socialLogin = (type, history) => async (dispatch) => {
  try {
    let response;

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend();
      response = fireBaseBackend.socialLoginUser(type);
    }
    //  else {
      //   response = postSocialLogin(data);
      // }
      
      const socialdata = await response;
    if (socialdata) {
      sessionStorage.setItem("authUser", JSON.stringify(response));
      dispatch(loginSuccess(response));
      history('/bots')
    }

  } catch (error) {
    dispatch(apiError(error));
  }
};


export const update_user_image_= (data) => async (dispatch) => {

  try {
    dispatch(enable_login_loader())
      
    const response = update_user_image(data)

    const api_response = await response;

    dispatch(set_user_image_success(api_response.image_url))
    localStorage.setItem('user_image', api_response.image_url)

  } catch (error) {
    dispatch(set_user_image_fail())
    console.log(error);
  }
   
  

}


export const update_user_details_= (data) => async (dispatch) => {
  try {
    dispatch(enable_login_loader())

    const response = update_user_details(data)

    await response;
    
    const resposne_2 = get_user_details()

    const api_response_data  = await resposne_2

    dispatch(update_user_details_success(api_response_data))
    

    if(data?.key === 'email')
      {
        dispatch(open_success_modal('Verification Email Sent', 'Please check your email for the verification link'))
      }
    if(data?.key === 'phone'){
      dispatch(open_success_modal('Phone Number Changed Successfully'))
    }



  } catch (error) {
    dispatch(set_user_image_fail())
    console.log(error)
  }
     
 


}




export const resetLoginFlag = () => async (dispatch) =>{
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error));
  }
};



export  const get_user_details_ = () => async (dispatch) => {
  const resposne_2 = get_user_details()

  const api_response_data  = await resposne_2

  dispatch(update_user_details_success(api_response_data))
}